import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FabSaveComponent } from './fab-save/fab-save.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [FabSaveComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  exports: [FabSaveComponent],
})
export class FabButtonModule {}
